/***
**Module Name: Signup 
 **File Name :  Signup.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 27 2022
 **Last modified on: Dec 27 2022
 **Description : contains Signup details.
 ***/
import React, { useState, useRef, useEffect, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import axios from 'axios';

import moment from "moment";
import { useNavigate } from "react-router-dom";
import * as Config from "../constants/Config";
import OTPInput from "otp-input-react";
import { contentContext } from "../context/contentContext";
import { get } from "jquery";
let { lambda, appname } = window.app;

const SignUp = () => {
  const [number, setNumber] = useState("");
  const [emailError, setEmailError] = useState('');
  const [email, setEmail] = useState('');
  const [type, setType] = useState('');
  const [Corporate, setCorporate] = useState('');
  const [name, setName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyError, setCompanyError] = useState('');
  const [mpin, setInput] = useState({});
  const [otp, setOtp] = useState('');
  const [show, setShow] = useState(false);
  const [categoryerror, setCategoryError] = useState('');
  const [typeerror, setTypeError] = useState('');
  const [nameerror, setNameError] = useState('');
  const navigate = useNavigate();

  const [buttonText, setButtonText] = useState("Continue");
  const [validation, setValidation] = useState(false);
  const [isLoadVerify, SetIsLoadVerify] = useState(false);
  const [otperror, setOtpError] = useState('');
  const [countries, setCountries] = useState('');
  const [values, setValues] = useState('');
  const [error, setError] = useState('');
  const [config, setConfig] = useState({});
  const [activeLoad, setActiveLoad] = useState("");
  const [defaultCountryCode, setDefaultCountryCode] = useState("");
  const [locData, setLocData] = useState("");

  const [otpclass, setOtpClass] = useState(false);
  const { userAgent } = useContext(contentContext)

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  let id = params.id;
  const one = useRef();
  const two = useRef();
  const three = useRef();
  const four = useRef();
  const five = useRef();



  useEffect(() => {
  

    if (id) {
  
      GetClientDataFunction()
    }
  }, [id])


  useEffect(() => {
      if (localStorage.getItem("token")) {
      navigate("/content");
    }
    setLocData(JSON.parse(localStorage.getItem("loc")));
    if (localStorage.getItem("loc") === null) {
      userAgent();
      clientActivity();
    } else {
      clientActivity();
    }

    GetCountries();



  }, []);

  useEffect(() => {
    if (window.site) {
      setConfig(window.site);
      let k = window.site && window.site.common && window.site.common.verificationRequired && window.site.common.verificationRequired ? 'Verify & Continue' : 'Continue'
      if (!id) {
        setButtonText(k)
      }

    }
  }, [window.site]);

  var verificationRequired = window.site && window.site.common && window.site.common.verificationRequired && window.site.common.verificationRequired





  if (window.site === undefined) {
    setTimeout(function () {
      if (window.site && window.site.common && window.site.common.imagesCDN) {
        var img = window.site.common.imagesCDN;
      }
    }, 1000);
  }
  if (window.site && window.site.common && window.site.common.imagesCDN) {
    var img = window.site.common.imagesCDN;
  }

  const GetClientDataFunction = async () => {
    try {
      // console.log('context/contentContextcontext/contentContext')
      const response = await tmdbApi.getClientData(id);
      console.log('responseeee', response)
      const result = response?.result?.result?.[0]
      setEmail(result?.personalemail)
      setCorporate(result?.entity)
      setType(result?.type)
      setName(result?.name)
      setNumber(result?.phone)
      setValues(result?.idc)
      setCompanyName(result?.companyname?.[0])
      setShow(true)
      setButtonText('Verify & Create');
      setNumber(result?.personalphone)
    } catch {
      console.log("error");
    }
  };
  const GetCountries = async () => {
    try {

      const response = await tmdbApi.getLookUp({
        "type": ["country"],
        "sortBy": "alpha3"
      });


      setCountries(response.result);
      if (localStorage.getItem("loc") !== null) {
        let userAgentData = JSON.parse(localStorage.getItem("loc"))
        let temp = userAgentData?.headers['cloudfront-viewer-country'][0]?.value
        setDefaultCountryCode(temp)

        let k = response?.result?.length > 0 && response?.result?.filter(eachItem => eachItem.alpha2 === temp)
        if (!id) {
          setValues(k[0].alpha3)
        }

      }


    } catch {
      console.log("error");
    }
  };

  const checkInput = (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, "");
    setNumber(onlyDigits);

  };




  const emailValidation = (e) => {
    let flag = true;
    const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
    if (regEx.test(email)) {
      setEmailError("");

    } else if (!regEx.test(email) && email !== "") {
      setEmailError("Email is Not Valid");
      flag = false;
    }
    if (email === "") {
      setEmailError("Please Enter Email");
      flag = false;
    }
    return flag

  }



  const handleTypeClick = (e, type) => {
    if (type) {
      setTypeError("");
    }
    setType(type);
  }

  const handlestatusClick = (e, type) => {
    setCompanyName("")
    if (type) {
      setCategoryError("");
    }
    setCorporate(type);

  }

  function formvalidation() {
    let formIsValid = true;
    const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
    if (regEx.test(email)) {
      setEmailError("");
    } else if (!regEx.test(email) && email !== "") {
      setEmailError("Email is Not Valid");
      formIsValid = false;
    }

    if (type === "") {
      setTypeError("Please Select Type");
      formIsValid = false;
    }

    if (Corporate === "") {
      setCategoryError("Please Select Corporate");
      formIsValid = false;
    }
    if (name?.trim() === "") {
      setNameError("Please Enter Name");
      formIsValid = false;
    }
    if (email?.trim() === "") {
      setEmailError("Please Enter Email");
      formIsValid = false;
    }
    if (Corporate === "COMPANY" && companyName?.trim() === "") {
      setCompanyError("Please Enter Company Name");
      formIsValid = false;
    }

    return formIsValid;


  }
console.log('buttonTextttttt', buttonText)
  const handleStatus = (e) => {
    console.log('handleStatus triggered')


    SetIsLoadVerify(true)
    localStorage.setItem("email", email);
    if (buttonText === 'Verify & Continue') {
      const isValid = formvalidation();
      if (isValid) {
        // console.log('asdfasd is valid')
        setButtonText('Verify & Create');
        console.log('VERIFY & CONTINUE and signup triggered')
        if (activeLoad == "") {
          clientActivity();
          signUp();
        }
      }
    } else if (buttonText === 'continue') {
      const isValid = formvalidation();
      if (isValid) {

        if (activeLoad == "") {
          clientActivity()
          signUp();
        }
        console.log('CONTINUE singup calll ')

      }
    }




    if (buttonText === 'Verify & Create') {

      if (otp.length === undefined) {
        setOtpError("Please Enter Otp");
        setActiveLoad("")
        setTimeout(function () { setOtpError("") }, 3000);
        console.log('otp undefined block')

      } else {
        console.log('otpVerifyyyyyyyyyyy calll ')
        if (activeLoad == "") {
          otpVerify();
        }

      }
    }

  }


  const clientActivity = () => {
    let path = window.location.pathname.split("/");

    var presentTime = moment();
    let payload;

    payload = {
      "pagename": 'SIGNUP',
      "pageurl": window.location.href,
      "starttime": presentTime,
      "useragent": JSON.parse(localStorage.getItem("loc")),
      "userType": type,
      "corporate": Corporate,
      "name": name,
      "idc": values,
      "phone": number,
      "companyname": Corporate === "INDIVIDUAL" ? [name] : Corporate === 'COMPANY' ? [companyName] : [],
      "clienttype": "ONLINE",
      "emailid": email,
    };
    const filteredObject = {};
    for (let key in payload) {
      if (payload[key] !== '' && payload[key] !== undefined && !(Array.isArray(payload[key]) && payload[key].length === 0)) {
        filteredObject[key] = payload[key];
      }
    }


    let urlLink;
    if (localStorage.getItem("previousid")) {
      urlLink = lambda + '/activity?appname=' + appname + "&previousid=" + localStorage.getItem("previousid")
    } else {
      urlLink = lambda + '/activity?appname=' + appname
    }

    axios({
      method: 'POST',
      url: urlLink,
      data: filteredObject
    })
      .then(function (response) {
        if (response.data.statusCode === 200) {
          localStorage.setItem("previousid", response.data.result)
        }
      });
  }
  // console.log('Corporate', Corporate)

  const signUp = async () => {
    console.log('signup call triggered ')
    try {
      console.log('signup try block')
      setActiveLoad("signUpActive")
      const response = await tmdbApi.signUp({
        "userType": type != "" && type !== undefined ? type : "",
        "corporate": Corporate != "" && Corporate !== undefined ? Corporate : "",
        "name": name != "" && name !== undefined ? name : "",
        "idc": values != "" && values !== undefined ? values : "",
        "phone": number != "" && number !== undefined ? number : "",
        "companyname": Corporate === "INDIVIDUAL" ? [name] : Corporate === 'COMPANY' ? [companyName] : [],
        "clienttype": "ONLINE",
        "emailid": email != "" && email !== undefined ? email : "",
        "useragent": locData?.headers !== undefined ? locData?.headers : {}
      });


      if (response.statusCode === 200 && response.result === "Success") {
        setShow(true);

      } else if (response.result === "User already exists") {
        setShow(false);
        setError("Email Already Exist. Please Enter another Email");
        if (verificationRequired === false) {
          setButtonText("Continue");
        } else {
          setButtonText("verify & Continue");

        }
      }
      else if (response.result === "PENDING VERIFICATION") {
        setShow(true);
      }
      else if (response.result === "PENDING APPROVAL") {
        setError("Please Wait For Admin Approval");
        setTimeout(function () { navigate("/message") }, 3000);

      }

      else if (response.result === "PENDING TERMS") {
        navigate("/terms/" + email);

      }
      else {
        setError("Something Went Wrong Please Try Again");

      }
      setActiveLoad("")
      SetIsLoadVerify(false)
    } catch {

      setActiveLoad("")
      console.log("signup block error");
    }
  };
  const validateEmail = (e) => {

    setEmail(e.target.value);




  }
  const handleResendOtp = async () => {
    const valid = emailValidation()
    if (valid) {
      setActiveLoad("ResendActive")
      setTimeout(function () {
        setActiveLoad("")
      }, 3000)
      try {
        console.log(tmdbApi);
        const response = await tmdbApi.resendMail({
          "emailid": email,
          "page": "signup"
        });
        console.log(response);

      } catch {
        setActiveLoad("")
        console.log("error");
      }
    }
  };



  const otpVerify = async () => {
    try {
      setActiveLoad("signUpActive")
      const response = await tmdbApi.otpVerify({
        "otp": Number(otp),
        "emailid": email
      });
      if (response.result == "User verified Successfully") {

        console.log('otp verify block user verified and redirect to terms page')
        navigate("/terms/" + email);
      }
      else {
        setOtpClass(true)
      }
      setActiveLoad("")
    } catch {
      setActiveLoad("")
      console.log("error");
    }
  };

  const handlecancel = (e) => {
    navigate("/");
  }

  const handleMessage = (e) => {
    setNameError("");
  }
  const handleEmailMessage = (e) => {
    setError("");
    setEmailError("");
  }
  const handleCompanyMessage = (e) => {
    setCompanyError("");
  }
  const handleOtpError = (e) => {
    console.log("came");

    setOtpClass(false)
  }

  const handleChange = (otp) => {
    setOtpClass(false);
    setOtp(otp)
  };
  useEffect(() => {
    document
      .querySelectorAll('.signin-otp-input')
      .forEach((el, idx) => el.setAttribute('id', `signin-otp-${idx + 1}`));
  }, [show]);

  let k = countries && countries.length > 0 && countries.filter(eachItem => eachItem.alpha2 === defaultCountryCode)

  return (
    <>

      <div className="header-wrapper">

        <a className="navbar-brand" onClick={handlecancel}>
          <img src={`${img}orasi/client/resources/orasiv1/images/logo_white.png`} alt="Logo" />
         
        </a>

        <p id="signin-prompt" className="signup-prompt">
          Already have an Account
          <a id="signin-link" href="/login" className="mx-2">Sign In</a>
        </p>

      </div>
      {/* <button id="close-btn" className="close-btn" onClick={handlecancel}>
    <span id="close-icon" className="material-icons">close</span>
  </button> */}
      <div className="sign-in-bg"></div>
      <div className="new-sign-up-wrapper">
        <div id="sign-wrapper" className="sign-wrapper">
          <div id="sign-header" className="sign-header">
            <a id="logo-link" href="/">
              <img
                id="logo"
                src={"https://d2aif2zmoi437u.cloudfront.net/orasi/client/resources/orasiv1/images/logoupdated.png?auto=compress,format"}
                className="logo"
              />
            </a>
            <p className="about-hero-subtitle text-center">Marketplace</p>
            <h1 id="create-account-heading">Create Account</h1>
            {/* <p id="join-text">Join Orasi Media to explore content</p> */}
          </div>

          <div id="sign-body" className="sign-body">
            <div id="choose-type-block" className="sign-block">
              <h2 id="choose-type-title" className="title">I Want to</h2>
              <div id="choose-type-options" className="flex-center">
                <button id="btn-buyer" className={type === "BUYER" ? "icon-btn buy-icon-bg selected" : "icon-btn buy-icon-bg"} onClick={e => handleTypeClick(e, "BUYER")} disabled={id ? true : false}>
                  BUY
                </button>
                <button id="btn-seller" className={type === "SELLER" ? "icon-btn sell-icon-bg selected" : "icon-btn sell-icon-bg"} onClick={e => handleTypeClick(e, "SELLER")} disabled={id ? true : false}>
                  SELL
                </button>
                <button id="btn-both" className={type === "BOTH" ? "icon-btn both-icon-bg selected" : "icon-btn both-icon-bg"} onClick={e => handleTypeClick(e, "BOTH")} disabled={id ? true : false}>
                  BOTH
                </button>
              </div>
              {typeerror != "" ? <span id="type-error" className="errormsg mssg-p" style={{ fontWeight: 'bold', color: 'red' }}>{typeerror}</span> : ""}
            </div>

            <div id="choose-status-block" className="sign-block type-block">
              <h2 id="choose-status-title" className="title">I'm</h2>
              <div id="choose-status-options" className="flex-center">
                <button id="btn-individual" className={Corporate === "INDIVIDUAL" ? "icon-btn individual-icon-bg sm-font selected" : "icon-btn individual-icon-bg sm-font"} onClick={e => handlestatusClick(e, "INDIVIDUAL")} disabled={id ? true : false}>
                  Individual
                </button>
                <button id="btn-company" className={Corporate === "COMPANY" ? "icon-btn company-icon-bg sm-font selected" : "icon-btn company-icon-bg sm-font"} onClick={e => handlestatusClick(e, "COMPANY")} disabled={id ? true : false}>
                  Company
                </button>
              </div>
              {categoryerror != "" ? <span id="category-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{categoryerror}</span> : ""}
            </div>

            <div id="tab-content" className="tab-content p-3 text-muted">
              <div id="personal-details-block" className="sign-block">
                <h2 id="personal-details-title" className="title mb-3">Enter Your Personal Details</h2>

                <div id="name-field" className="mb-3 field-set">
                  <label htmlFor="name" className="form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Enter Name"
                    name="fullname"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onFocus={(e) => handleMessage(e)}
                    autoComplete="on"
                    required
                    disabled={id ? true : false}
                  />
                  {nameerror !== "" && (
                    <span
                      id="name-error"
                      className="errormsg"
                      style={{ fontWeight: "bold", color: "red" }}
                    >
                      {nameerror}
                    </span>
                  )}
                </div>

                <div id="phone-block" className="mb-3 custom-drop_down field-set">
                  <label htmlFor="phone-number" className="form-label">
                    Contact Number
                  </label>
                  <div className="d-flex">
                    <select
                      id="country-code-select"
                      name="countryCodeAlpha2"
                      value={values}
                      className="form-select colorselect capitalize"
                      onChange={(e) => setValues(e.target.value)}
                      disabled={id ? true : false}
                      style={{ maxWidth: "120px" }}
                    >
                      <option value={k && k[0] && k[0].alpha3}>
                        {k && k[0] && k[0].alpha3}
                        {k && k[0] && k[0].countrycode}
                      </option>
                      {countries &&
                        countries.length > 0 &&
                        countries.map((task, i) => (
                          <option key={i} id={`country-option-${i}`} value={task.alpha3}>
                            {task.alpha3}
                            {task.countrycode}
                          </option>
                        ))}
                    </select>

                    <input
                      id="phone-number"
                      type="text"
                      className="field form-control"
                      placeholder="Enter Phone Number"
                      maxLength="10"
                      value={number}
                      name="phonenumber"
                      onChange={(e) => checkInput(e)}
                      autoComplete="on"
                      disabled={id ? true : false}
                    />
                  </div>
                </div>


                <div id="email-field" className="mb-3 field-set">
                  <label htmlFor="email" className="form-label">
                    Email Id
                  </label>
                  <input
                    id="email"
                    type="email"
                    className="form-control"
                    name="emailid"
                    placeholder="name@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onFocus={(e) => handleEmailMessage(e)}
                    autoComplete="on"
                    disabled={id ? true : false}
                  />
                  <span
                    id="email-error"
                    className="errormsg"
                    style={{ fontWeight: "bold", color: "red" }}
                  >
                    {emailError}
                  </span>
                </div>

              </div>

              {Corporate == "COMPANY" &&
                <div id="company-details-block" className="sign-block">
                  <div>
                    <h2 id="company-details-title" className="title mb-4">Enter Your Company Details</h2>
                    <div id="company-field" className="mb-3 field-set">
                      <label htmlFor="company" className="form-label">
                        Company Name
                      </label>
                      <input
                        id="company"
                        type="text"
                        className="form-control"
                        placeholder="Enter Company Name"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        onFocus={(e) => handleCompanyMessage(e)}
                        disabled={id ? true : false}
                      />
                      {companyError !== "" && (
                        <span
                          id="company-error"
                          className="errormsg"
                          style={{ fontWeight: "bold", color: "red" }}
                        >
                          {companyError}
                        </span>
                      )}
                    </div>

                  </div>
                </div>
              }

              {show === true &&
                <div id="otp-block" className="otp-block">
                  <p id="otp-instruction">Enter the OTP we just sent to the above Email</p>
                  <div id="signin-otp-inputs" className={otpclass ? "otp-inputs signup-otp-inputs invalid errorStyle" : "otp-inputs signup-otp-inputs"}>

                    <OTPInput
                      value={otp}
                      onChange={handleChange}
                      autoFocus
                      OTPLength={5}
                      otpType="number"
                      onFocus={(e) => handleOtpError(e)}
                      inputClassName="signin-otp-input"
                      inputProps={{
                        "data-testid": "signin-otp-input"
                      }}
                    />

                    <p id="otp-error-msg">The OTP you have entered is incorrect. Please try again or request a new OTP</p>
                  </div>
                  <div id="otp-footer" className="otp-footer">
                    <button id="resend-otp-btn" onClick={handleResendOtp}>
                      {activeLoad === "ResendActive" ? (<img id="resend-loading-icon" src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) : null}
                      Resend
                    </button>
                    {activeLoad === "ResendActive" ? <p id="otp-resent-msg" style={{ fontSize: '12px', color: 'green' }}>OTP Resent!</p> : null}
                  </div>
                </div>
              }

              <div id="signup-block" className="signup sign-up-wrapper">
                <button
                  id={
                    buttonText === "Verify & Continue"
                      ? "verify-continue-btn"
                      : buttonText === "Continue"
                        ? "continue-btn"
                        : buttonText === "verify & Create"
                          ? "verify-create-btn"
                          : "signup-btn"
                  }
                  className="custom-btn-primary about-hero-btn flex items-center justify-center gap-2"
                  onClick={(e) => handleStatus(e)}
                >
                  {activeLoad === "signUpActive" && (
                    <img
                      id="signup-loading-icon"
                      src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"}
                      className="loading-icon"
                    />
                  )}
                  <span className="button-txt">{buttonText}</span>
                  <span className="material-icons">north_east</span>
                </button>

              </div>

              {error != "" ? <span id="signup-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{error}</span> : ""}

            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default SignUp;
